import React from 'react';
import { ComponentSettingsManageFilters, ComponentSettingsExternalVisualization } from '@report-content';

export interface IBlocksContext {
    manageFiltersSettings: ComponentSettingsManageFilters | null;
    // Top Filters State (Used by other Components)
    setFilters: (rules: any) => void;
    filters: any;
    // Visualization extVizString (Used by Dataset)
    setExtViz: (extViz: ComponentSettingsExternalVisualization | null) => void;
    extViz: ComponentSettingsExternalVisualization | null;
    setManageFiltersReady: (ready: boolean) => void;
    manageFiltersReady: boolean;
    getFilterMask: (defaultFormat: string, filterReferenceName: string) => string;
}
export const BlocksContext = React.createContext<IBlocksContext | null>(null);
